import React from 'react';
import ReactMarkdown from 'react-markdown';
import type { Components } from 'react-markdown';
import { linkOpensNewTab, remarkMarkdownPlugins } from './smartAssistUtils';

const markdownComponents: Components = {
  a: ({ href, children, ...props }) => {
    const newTab = linkOpensNewTab(href);
    return (
      <a
        href={href}
        {...props}
        target={newTab ? '_blank' : undefined}
        rel={newTab ? 'noopener noreferrer' : undefined}
      >
        {children}
      </a>
    );
  },
};

export interface SmartAssistMarkdownProps {
  children: string;
}

export function SmartAssistMarkdown({ children }: SmartAssistMarkdownProps): React.ReactElement {
  return (
    <ReactMarkdown remarkPlugins={remarkMarkdownPlugins} components={markdownComponents}>
      {children}
    </ReactMarkdown>
  );
}
